/* SWT auto-gift (see snippets/auto-gift-z3.liquid for config). Fails silently. */
(function () {
  'use strict';
  try {
    var C = window.SWT_AUTO_GIFT;
    if (!C || !C.enabled || typeof window.fetch !== 'function') return;

    var F = window.__swtOrigFetch || window.fetch; // original fetch: our own calls are never seen by the watcher
    var TRIG = (C.triggerProductIds || []).map(Number);
    var GIFT_PID = Number(C.giftProductId);
    var GIFT_VIDS = (C.giftVariantIds || []).map(Number);
    var QTY = Math.max(1, parseInt(C.giftQuantity, 10) || 1);
    var KEY = 'swtAutoGift:';
    var GUARD_KEY = 'swtAutoGift:actions';
    var running = false, again = false, timer = null;

    var log = function () {
      if (C.debug && window.console) console.log.apply(console, ['[auto-gift]'].concat([].slice.call(arguments)));
    };
    var root = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };
    var api = function (path, opts) {
      var o = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
      if (opts) { for (var k in opts) o[k] = opts[k]; }
      return F.call(window, root() + path, o).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    };

    var ss = {
      get: function (k) { try { return JSON.parse(window.sessionStorage.getItem(k)); } catch (e) { return null; } },
      set: function (k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    };
    var tokenOf = function (cart) { return String((cart && cart.token) || 'none').split('?')[0]; };
    var isAuto = function (item) {
      var p = item && item.properties;
      return !!p && (p._auto_gift === 'true' || p._auto_gift === true);
    };

    // Loop guard: max 6 add/remove actions per 60s, survives page reloads.
    var guard = function () {
      var now = Date.now();
      var list = (ss.get(GUARD_KEY) || []).filter(function (t) { return now - t < 60000; });
      if (list.length >= 6) { log('loop guard tripped'); return false; }
      list.push(now);
      ss.set(GUARD_KEY, list);
      return true;
    };

    var addGift = function () {
      var i = 0;
      var next = function () {
        if (i >= GIFT_VIDS.length) return Promise.resolve(false);
        var id = GIFT_VIDS[i++];
        return api('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: id, quantity: QTY, properties: { _auto_gift: 'true' } }] })
        }).then(function () { log('added gift', id); return true; }, function (e) { log('add failed', id, e); return next(); });
      };
      return next();
    };

    var removeLines = function (lines) {
      return lines.reduce(function (p, line) {
        return p.then(function () {
          return api('cart/change.js', { method: 'POST', body: JSON.stringify({ id: line.key, quantity: 0 }) });
        });
      }, Promise.resolve());
    };

    var refresh = function () {
      try {
        var R = window.Rebuy;
        if (R && R.Cart && typeof R.Cart.fetchCart === 'function') R.Cart.fetchCart();
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('swt:auto-gift-updated')); } catch (e) {}
      try {
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      } catch (e) {}
    };

    var check = function () {
      if (running) { again = true; return; }
      running = true;
      api('cart.js').then(function (cart) {
        var t = KEY + tokenOf(cart);
        var st = ss.get(t) || {};
        var items = cart.items || [];
        var hasTrigger = items.some(function (it) { return TRIG.indexOf(Number(it.product_id)) > -1; });
        var giftLines = items.filter(function (it) { return Number(it.product_id) === GIFT_PID; });
        var autoLines = giftLines.filter(isAuto);

        if (hasTrigger) {
          if (giftLines.length) {
            if (autoLines.length && !st.added) { st.added = true; ss.set(t, st); }
            return false;
          }
          if (st.suppressed) return false;
          if (st.added) { // we added it earlier and it is gone -> customer removed it
            st.added = false; st.suppressed = true; ss.set(t, st);
            log('customer removed gift - not re-adding for this cart');
            return false;
          }
          if (!guard()) return false;
          return addGift().then(function (ok) {
            if (ok) { st.added = true; ss.set(t, st); }
            return ok;
          });
        }

        if (autoLines.length) {
          if (!guard()) return false;
          return removeLines(autoLines).then(function () {
            st.added = false; ss.set(t, st);
            log('trigger gone - removed gift');
            return true;
          });
        }
        if (st.added) { st.added = false; ss.set(t, st); }
        return false;
      }).then(function (changed) {
        if (changed) refresh();
      }).catch(function (e) {
        log('error', e);
      }).then(function () {
        running = false;
        if (again) { again = false; schedule(); }
      });
    };

    var schedule = function (ms) {
      clearTimeout(timer);
      timer = setTimeout(check, ms == null ? 350 : ms);
    };

    // 1) Any completed /cart/add|change|update|clear request (fetch or XHR, any app).
    document.addEventListener('swt:cart-mutated', function () { schedule(); });

    // 2) Backup for apps that kept their own copy of fetch: re-check after add-to-cart clicks.
    document.addEventListener('click', function (e) {
      try {
        var b = e.target && e.target.closest && e.target.closest('button, input[type="submit"], [role="button"]');
        if (!b) return;
        var txt = String(b.textContent || b.value || '').toLowerCase();
        if (b.name === 'add' || txt.indexOf('add to cart') > -1) {
          setTimeout(function () { schedule(0); }, 1500);
          setTimeout(function () { schedule(0); }, 4000);
        }
      } catch (err) {}
    }, true);

    // 3) Page load, and when the tab becomes visible again (cart may have changed in another tab).
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') schedule();
    });
    schedule(0);
  } catch (e) {}
})();
